export default "__VITE_ASSET__DzrUhCrD__"